<template>
    <div class="d-inline-block">
        <div v-if="source === 'file'">
            <i class="fas fa-upload mr-2 text-primary"/>Datei
        </div>
        <div v-if="source === 'url'">
            <i class="fas fa-link mr-2 text-primary"/>URL
        </div>
    </div>
</template>

<script>
export default {
    props: {
        source: String,
    },
}
</script>
